import React, { useState } from "react";
import "./Testimonials.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Common_title from "../../common-components/common_title/Common_title";

const Testimonials = () => {
  const data = [
    {
      review:
        "Excellent service and very professional staff. The doctor took time to explain everything clearly, and the entire process was smooth and stress-free.",
      img: "/assets/images/home/testimonials/circle-img.jpg",
      name: "Rajesh Kumar",
      desgn: "",
    },
    {
      review:
        "I had a very positive experience at Marine Medical Clinic. The staff was polite, the clinic was clean, and the care I received was outstanding.",
      img: "/assets/images/home/testimonials/circle-img.jpg",
      name: "Anita Sharma",
      desgn: "",
    },
    {
      review:
        "Marine Medical Clinic is well organized and efficient. Appointments were on time, and the medical team was knowledgeable and supportive throughout.",
      img: "/assets/images/home/testimonials/circle-img.jpg",
      name: "Suresh Patel",
      desgn: "",
    },
    {
      review:
        "I felt comfortable and well taken care of from the moment I arrived. The doctors and nurses were kind and professional. Truly excellent care.",
      img: "/assets/images/home/testimonials/circle-img.jpg",
      name: "Priya Nair",
      desgn: "",
    },
    {
      review:
        "Very satisfied with the service. The medical examination was thorough, and everything was explained clearly. I would definitely recommend this clinic.",
      img: "/assets/images/home/testimonials/circle-img.jpg",
      name: "Vikram Singh",
      desgn: "",
    },
  ];

  const [swiperInstance, setSwiperInstance] = useState(null);

  const handleMainSliderClick = (direction) => {
    console.log("swiperInstance", swiperInstance, direction);

    if (swiperInstance) {
      if (direction === "prev") {
        swiperInstance.slidePrev();
      } else if (direction === "next") {
        swiperInstance.slideNext();
      }
    }
  };
  return (
    <section className="testimonial_section">
      <div className="container">
        <div className="main_content_div">
          <div className="testiminial_title_holder">
            <Common_title text="⚓ TESTIMONIALS" />
          </div>

          <div className="testimonial_subtitle_holder">
            <p className="testimonial_subtitle">
              We take pride in supporting thousands of seafarers every year.
              Here’s what our clients have to say about their experience at
              Shore Clinic.
            </p>
          </div>

          <div className="swiper_div">
            <Swiper
              onSwiper={setSwiperInstance}
              slidesPerView={1}
              spaceBetween={10}
              modules={[Navigation]}
              breakpoints={{
                "0": {
                  slidesPerView: 1.2,
                  spaceBetween: 0,
                },
                "350": {
                  slidesPerView: 1.3,
                  spaceBetween: 0,
                },
                "450": {
                  slidesPerView: 1.6,
                  spaceBetween: 0,
                },
                "575": {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
                "768": {
                  slidesPerView: 2.5,
                  spaceBetween: 10,
                },
                "992": {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
                "1200": {
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
                "1400": {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
              }}
              centeredSlides={true}
              loop={true}
              className="mySwiper"
            >
              {data.map((item) => (
                <SwiperSlide>
                  <div className="white_review_card">
                    <div className="quote_img_div">
                      <img
                        src="/assets/images/home/testimonials/comma.png"
                        className="quote_img"
                      />
                    </div>

                    <p className="review_text">{item?.review}</p>

                    <div className="img_holder">
                      <img
                        src={process.env.PUBLIC_URL + item?.img}
                        className="profile_img"
                      />
                    </div>
                    <p className="name_text">{item?.name}</p>
                    <p className="desgn_text">{item?.desgn}</p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            {/* <div className="silder_btn"> */}
            <div
              className="back_btn_holder"
              onClick={() => handleMainSliderClick("prev")}
            >
              <div className="back_btn">
                <p>
                  {" "}
                  <FontAwesomeIcon icon={faAngleLeft} className="icon" />
                </p>
              </div>
            </div>
            <div
              className="back_btn_holder next"
              onClick={() => handleMainSliderClick("next")}
            >
              <div className="back_btn">
                <p>
                  {" "}
                  <FontAwesomeIcon icon={faAngleRight} className="icon" />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
